(function () {
    'use strict';
    angular
        .module('app.core')
        .filter('replace', replace);
    function replace() {
        return replaceFilter;

        function replaceFilter(input, from, to) {
            input = input || '';
            from = from || '';
            to = to || '';
            return input.replace(new RegExp(from, 'g'), to);
        }
    }
})();